import React, { useState } from "react";
import { Add } from "@material-ui/icons";
import { Box, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import UploadedSection from "./UploadedSection";
import FileUploader from "@jumbo/Dashboards/Media/FileUploader";

const useStyles = makeStyles(() => ({
  container: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBlock: "20px",
    flexDirection: "column",
  },
}));

function FilePickerContainer({ media, setMedia }) {
  const classes = useStyles();
  const [openFileUploader, setOpenFileUploader] = useState(false);
  const handleSelect = (selected) => {
    const allMedia = [...media];
    setMedia([...allMedia, selected]);
  };

  return (
    <>
      <Box className={classes.container}>
        <Button
          variant="outlined"
          color="primary"
          startIcon={<Add />}
          onClick={() => setOpenFileUploader(true)}
        >
          افزودن رسانه
        </Button>
        <UploadedSection allMedia={media} setMedia={setMedia} />
      </Box>
      <FileUploader
        selectMode
        open={openFileUploader}
        handleClose={() => setOpenFileUploader(false)}
        handleSelectGallery={(selected) => handleSelect(selected)}
        gallerySlected={media[media.length - 1]}
        gallerySelctor={true}
      />
    </>
  );
}

export default FilePickerContainer;
